/**
 * EndosigExploreComponent
 * Displays topic selection and variable filters to select a question
 */
/* D3 library used to select elements from DOM, and build charts */
declare const d3: any;
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Question } from '../../models/question.class';
import { DataEndosigService } from '../../services/data-endosig/data-endosig.service';
import * as _ from 'lodash';
import { UtilsService } from '../../services/utils/utils.service';
import { MatAutocompleteTrigger } from '@angular/material';
/**
 * ENDOSIG Explore lets choose through 2 filters of Topic and subtopic, a variable of interest
 */
@Component({
  /** Selector from component  */
  selector: 'app-endosig-explore',
  /** HTML used for this component  */
  templateUrl: './endosig-explore.component.html',
  /** Style in sass used for this component  */
  styleUrls: ['./endosig-explore.component.scss']
})
/**
* class EndosigExploreComponent, main class for this module
*/
export class EndosigExploreComponent implements OnInit, AfterViewInit {
  /**
  * Trigger for Variable Autocomplete
  */
  @ViewChild(MatAutocompleteTrigger) trigger: MatAutocompleteTrigger;
  /** Var who marks the number of aplication flow */
  step: number;
  /** Selected topics in string */
  selectedTopicName: string;
  /** Topic whichs filters variables  */
  selectedTopic: { key: string, values: {}[] };
  /** SubTopic whichs filters variables  */
  selectedSubtopic: { key: string, values: Question[] }; // Limpieza
  /** Question selected, which display it`s information in the next module  */
  selectedQuestion: Question;
  /** Contains all variables from ENDOSIG  */
  allVariables: Array<Question> = [];
  /** Contains the variables after topic and subtopic filters  */
  variables: Array<Question> = [];
  /** Contains all topics used in ENDOSIG  */
  allTopics: Array<any> = [];
  /** subtopic brought by filter topic   */
  groupTopic: Array<any> = [];
  /** Aux to save topics */
  allVariable: Array<Question> = [];
  /** Names of the topics */
  topicsNames: any;
  /** Topics that match to a variable topic  */
  topicVariables: Array<any> = [];
  /** Structure of how a topic is processed */
  topics: { key: string, values: {}[] }[] = [];
  /** Structure of how a subtopic is processed */
  allSubTopics: { key: string, values: {}[] }[] = [];
  /** Array of subtopics */
  subtopics: Array<Object> = [];
  /** FormControl instance to validate questions search */
  searchVariable: FormControl;
  /** Observable instance for questions dropdown autocomplete */
  filteredVariables: Observable<any>;
  /**
  * Used to show user know if selecting Topic or subtopic
  */
  showGroups = {
    state: true,
    subText: ' TEMA',
    subTopic: ' SUBTEMA'
  };
  /** Set an empty object to catch params from URL */
  queryParams = {};
  /** Variables related to selected subtopic */
  subtopicVariables: any;
  /** Names of subtopics that can be selected */
  subtopicsNames: {}[];
  /** Name of the current selected subtopic */
  selectedSubTopicName: any;
  /** True if subtopic is Reconocimiento de orientación sexual e identidad de género de la población encuestada */
  showStyle: boolean;

  /**
   * Constructor of class EndosigExploreComponent
   * @param dbService Instance of dbService class to do some requests to database
   * @param utils Instance of utils class
   */
  constructor(
    private dbService: DataEndosigService,
    private utils: UtilsService) { }
  /**Angular lyfecicle method  */
  ngAfterViewInit() {
  }

  /**
   * This method is called on component initialization
   */
  ngOnInit() {
    /** Initalize 'step' variable */
    this.step = 0;
    /** New instance of FormControl for searchVariable form */
    this.searchVariable = new FormControl();
    /** Set initial value to searchVariable: 'undefined' means 'no question selected yet' */
    this.searchVariable.setValue(undefined);

    /** Load catalog of questions */
    this.dbService.getCodebook()
      .subscribe(questions => {
        /** Object that contains all question from survey */
        this.allVariables = questions.map(obj => new Question(obj)); // Map data to Question objects
        /** Variables sorted by criteria */
        this.variables = this.allVariables.sort(this.sortVariables);
        this.searchTopics(this.variables);
        this.filteredVariables = this.searchVariable.valueChanges
          .pipe(
            startWith(''),
            map(variable => variable ? this.filterVariables(variable) : this.variables.slice().sort(this.sortVariables))
          );
      });
  }

  /**
   * Reads every question's topic then process topics obtained
   * Finally return topics in object structure { name: e, slug: e }
   * @param questions Means all questions used in ENDOSIG
   */
  searchTopics(questions) {
    const qtopic = questions.filter(function (q) {
      if (q && q.topic && q.topic.includes(',')) {
        q.topic = q.topic.split(',');
      }
      return q.topic !== '';
    });

    this.allTopics = qtopic;
    this.topicVariables = qtopic.map(obj => new Question(obj));

    const justTopic = _.flatten(qtopic.map(function (a) {
      return a.topic;
    }));

    this.topicsNames = _.uniq(justTopic).filter(g => g);

    this.topicsNames = this.topicsNames.map((e) => {
      return { name: e, slug: e };
    });
  }

  /** Reads topic selected by user, and filter variables by that topic
  * Checks what's gonna be the value of this.showStyle variable
  * @param context Means the topic selected by user
  */
  setTopic(context) {
    this.selectedTopicName = context.name;
    this.selectedTopic = context.slug;
    this.allVariable = this.allTopics.filter(function (fa) {
      const result = fa.topic === context.slug || (Array.isArray(fa.topic) &&
        _.includes(fa.topic, context.slug));
      return result;
    }.bind(this));
    this.topicVariables = this.allVariable;
    this.variables = this.allVariable;
    this.searchVariable.setValue(undefined);
    this.groupTopic = _.uniqBy(this.allVariable, 'subtopic');
    this.step = 0;
    this.queryParams = {
      topic: context.slug
    };
    this.nextStep();
    if (context.name === 'Reconocimiento de orientación sexual e identidad de género de la población encuestada') {
      this.showStyle = true;
    } else {
      this.showStyle = false;
    }
  }

  /**
   * Reads subtopic selected by user, and filter variables by that subtopic
   * @param atopic Means subtopic selected by user
   */
  setSubTopic(atopic) {
    this.selectedSubtopic = atopic.subtopic;
    this.variables = this.topicVariables.filter(function (fv) {
      return fv.subtopic === atopic.subtopic;
    });
    this.searchVariable.setValue(undefined);
    this.step = 1;
    this.queryParams['tema'] = atopic;
    this.nextStep();
  }

  /**
   * Method to be called when wanted to order variables Alphabetically. Compare variable a vs b
   * @param a Variable 1 to compare
   * @param b Variable 2 to compare
   */
  sortVariables(a: Question, b: Question) {
    return a.shortName.localeCompare(b.shortName, undefined, { numeric: true });
  }

  /**
   * Calls method sortVariables, to order and a special function to quit spanish characters
   * and have homologated structure of variable numbers
   * @param name Variable shortname used for every time the function and subfunctions run
   */
  filterVariables(name: string) {
    if (typeof name === 'string') {
      return this.variables.filter(variable =>
        this.utils.stripSpecialCharacters(variable.shortName).indexOf(
          this.utils.stripSpecialCharacters(name)) > -1).sort(this.sortVariables);
    } else if (name['question']) {
      // variable is a selected object
      return this.variables.filter(variable =>
        this.utils.stripSpecialCharacters(variable.shortName).indexOf(
          this.utils.stripSpecialCharacters(name['shortName'])) > -1).sort(this.sortVariables);
    }
  }

  /**
   * Set which step the app is in
   * @param index Actual step of app's flow
   */
  setStep(index: number) {
    this.step = index;
  }

  /**
   * Increase one the step of app's flow
   */
  nextStep() {
    this.step++;
    if (this.step === 2) {
      setTimeout(() => {
        this.trigger.openPanel();
      }, 300);
    }
  }

  /**
   * Decrease one the step of app's flow
   */
  prevStep() {
    this.step--;
  }
  /**
   * At first, display first postion of variable according to Topic and subtopic filters
   * Then if user select a variable; Display the variable selected
   * @param variable Means the variable to display
   */
  displayFn(variable?: Question): string | undefined {
    return variable ? variable.shortName : undefined;
  }
  /** Sets null the value of Variable's autocomplete  */
  eraseSearch() {
    this.searchVariable.setValue(undefined);
  }
  /**
   * Assign value of variable selected by user to var used in this module
   * @param event Means an event who contains value of variable selected in structure needed
   */
  selectVariable(event) {
    this.selectedQuestion = this.searchVariable.value;
  }

  /**
   * Just works when subtopic value is "Reconocimiento de orientación sexual
   * e identidad de género de la población encuestada", the container button, gets bigger
   */
  getWidth() {
    if (this.showStyle) {
      return '50%';
    } else {
      return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/endosig/endosig-explore/endosig-explore.component.ts